import React, {Component} from 'react';
import ImageAPI from "../classes/ImageAPI";
import Img from 'react-image';
class VenueImage extends Component {
  constructor(props) {
    super(props);
    this.state = {image: null};
    this.imageAPI = new ImageAPI();
    this.imageAPI.embedImage(this.props.mid, 'teaser').then((results) => {
      this.setState({image: results});
    });
  }

  componentDidMount() {
    if (!this.state.image) {
      this.imageAPI.embedImage(this.props.mid, 'teaser').then((results) => this.setState({image: results}));
    }
  }

  render() {
    if (this.state.image) {
      return (
        <Img src={this.state.image.uri}
             alt=""
             loading="lazy"
        />
      );
    } else {
      return  (<div>...</div>)
    }
  }
}

export default VenueImage;
